const linkBaseUrl = `${window.location.protocol}//${window.location.host}`;
const baseUrl = 'https://scdevwww.lotsmall.cn/';
const qyyxUrl = 'https://qyyxwap.lotsmall.cn';
export {
    linkBaseUrl,
    baseUrl,
    qyyxUrl,
}